<template>
  <v-menu open-on-click top transition="slide-x-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn :color="iconColor" v-bind="attrs" v-on="on" icon :title="tooltip">
        <v-icon>{{ openIcon }}</v-icon>
      </v-btn>
    </template>

    <div class="dropdown">
      <slot name="header" />
      <slot name="content" />
      <slot name="footer" />
    </div>
  </v-menu>
</template>

<script>
export default {
  name: 'Dropdown',
  props: ['openIcon', 'iconColor', 'tooltip'],
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/inputs.scss';
</style>
